import accessories from 'stores/modules/accessories'
import accessoriesCategorization from 'stores/modules/accessories-categorization'
import attributes from 'stores/modules/attributes'
import buyingOptions from 'stores/modules/buying-options'
import characteristics from 'stores/modules/characteristics'
import insuranceCompanies from 'stores/modules/insurance-companies'
import insurances from 'stores/modules/insurances'
import personalizations from 'stores/modules/personalizations'
import properties from 'stores/modules/properties'
import proposalModels from 'stores/modules/proposal-models'
import referencePoints from 'stores/modules/reference-points'
import registryOffices from 'stores/modules/registry-offices'
import bankAgencies from 'stores/modules/bank-agencies'

// installmentIntegrationTables
import installmentIntegrationTables from 'stores/modules/installment-integration-tables/installment-integration-tables'
import installmentIntegrationTablesRealEstateDevelopments from 'stores/modules/installment-integration-tables/installment-integration-tables-real-estate-developments'

// realEstateDeveopments
import realEstateDevelopments from 'stores/modules/real-estate-developments/real-estate-developments'
import realEstateDevelopmentsAccessories from 'stores/modules/real-estate-developments/real-estate-developments-accessories'
import realEstateDevelopmentsBlueprints from 'stores/modules/real-estate-developments/real-estate-developments-blueprints'
import realEstateDevelopmentsCharacteristics from 'stores/modules/real-estate-developments/real-estate-developments-characteristics'
import realEstateDevelopmentsDocuments from 'stores/modules/real-estate-developments/real-estate-developments-documents'
import realEstateDevelopmentsInitialRegister from 'stores/modules/real-estate-developments/real-estate-developments-initial-register'
import realEstateDevelopmentsMapsReferences from 'stores/modules/real-estate-developments/real-estate-developments-maps-references'
import realEstateDevelopmentsMedias from 'stores/modules/real-estate-developments/real-estate-developments-medias'
import realEstateDevelopmentsMirrors from 'stores/modules/real-estate-developments/real-estate-developments-mirrors'
import realEstateDevelopmentsParameters from 'stores/modules/real-estate-developments/real-estate-developments-parameters'
import realEstateDevelopmentsStages from 'stores/modules/real-estate-developments/real-estate-developments-stages'
import realEstateDevelopmentsTags from 'stores/modules/real-estate-developments/real-estate-developments-tags'
import realEstateDevelopmentsTypologies from 'stores/modules/real-estate-developments/real-estate-developments-typologies'
import realEstateDevelopmentsTransfer from 'stores/modules/real-estate-developments/real-estate-developments-transfer'

// realEstateDevelopmentsUnits
import realEstateDevelopmentsUnits from 'stores/modules/real-estate-developments-units/real-estate-developments-units'
import realEstateDevelopmentsUnitsPrices from 'stores/modules/real-estate-developments-units/real-estate-developments-units-prices'

// realEstateDevelopmentsBatch
import realEstateDevelopmentsBatchInfo from 'stores/modules/real-estate-developments-batch/real-estate-developments-batch-info'
import realEstateDevelopmentsBatchPriceTables from 'stores/modules/real-estate-developments-batch/real-estate-developments-batch-price-tables'

// creditPolicies
import creditPolicies from 'stores/modules/credit-policies/credit-policies'
import creditPoliciesRealEstateDevelopments from 'stores/modules/credit-policies/credit-policies-real-estate-developments'

// reports
import reportsBlueprints from 'stores/modules/reports-blueprints'

import { hubStore as hub } from 'hub/pinia'

import { DefineGlobalPiniaStore } from '@bildvitta/store-adapter'
import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
  app.use(DefineGlobalPiniaStore, {
    stores: {
      accessories,
      accessoriesCategorization,
      attributes,
      buyingOptions,
      characteristics,
      hub,
      insuranceCompanies,
      insurances,
      personalizations,
      properties,
      proposalModels,
      realEstateDevelopments,
      realEstateDevelopmentsAccessories,
      realEstateDevelopmentsBatchInfo,
      realEstateDevelopmentsBatchPriceTables,
      realEstateDevelopmentsBlueprints,
      realEstateDevelopmentsCharacteristics,
      realEstateDevelopmentsDocuments,
      realEstateDevelopmentsInitialRegister,
      realEstateDevelopmentsMapsReferences,
      realEstateDevelopmentsMedias,
      realEstateDevelopmentsMirrors,
      realEstateDevelopmentsParameters,
      realEstateDevelopmentsStages,
      realEstateDevelopmentsTags,
      realEstateDevelopmentsTypologies,
      realEstateDevelopmentsUnits,
      realEstateDevelopmentsUnitsPrices,
      realEstateDevelopmentsTransfer,
      referencePoints,
      registryOffices,
      bankAgencies,
      installmentIntegrationTables,
      installmentIntegrationTablesRealEstateDevelopments,
      reportsBlueprints,
      creditPolicies,
      creditPoliciesRealEstateDevelopments
    }
  })
})
